module.exports = __webpack_public_path__ + "img/3D-Untergrund.49bb6b9f.jpg";